module.exports = __webpack_public_path__ + "ad78c066546ca4f5302668537557d338.svg";